import React from 'react'
import WeekDaysBoard from './WeekDaysBoard'
import Header from './Header'
//import ModalError from './ModalError'

const App = () => {

  return (
    <div className='App'>
        <Header />
        <WeekDaysBoard />
    </div>
  )
}

export default App